// extracted by mini-css-extract-plugin
export default {"container":"ConfigurationTableType_container__x-U6k"};